import React from 'react';
import '../styles/roboticsProduct.css'
import AnimationBox from '../animationBox';
import AnimatedArrowButton from './AnimatedArrowButton';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import product1 from '../assets/p9.png';
import product2 from '../assets/p10.png';
import product3 from '../assets/p11.png';
import product4 from '../assets/p12.png';


const Products3= () => {

    const sliderSettings = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows:false,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };

    const cards = [
        { name: 'PUDU CC1', company: "AI Powered Robotic Sweeper" , image:product1  },
        { name: 'PUDU SH1', company: "Smart Upright Scrubber Dryer" , image:product3  },
        { name: 'Bella Bot', company: "Premium Delivery Robot" , image:product2 },
        { name: 'SwiftBot', company: "Versatile Delivery Robot" , image:product4 }, 
        
      ];

    return(<div className='roboticsproduct mt-5 pb-4' style={{height:'auto'}}>

        
            <div className='roboticsproduct-inner' >
            
            <div className='myservices' style={{display:'flex',padding:'25px',gap:'10px',paddingTop:"2rem", width:'100%'}}>
                        
                        <div className='services-msg' style={{textAlign:'left', width:'100%'}}>
                            <div style={{display:'flex' , alignItems:'start', justifyContent:'space-between', width:'100%'}}><h1 style={{fontWeight:"600"}}>PUDU ROBOTS</h1> <div className='button1'> <AnimatedArrowButton  text="Learn More" link="https://www.pudurobotics.com/product"   /></div> </div>
                            <p style={{color:'white', fontSize:"14px"}}>PUDU robot used for cleaning and delivery services.</p>
                            <div className='button2'> <AnimatedArrowButton  text="Learn More" link="https://www.pudurobotics.com/product"   /></div> 
                        </div>
            </div>
            <hr></hr>
            <div style={{  maxWidth: "90%", margin: "auto" }}>
      <Slider {...sliderSettings}>
        {cards.map((card) => (
          <div key={card.id} style={{ padding: "10px"}}>
            <div
              style={{
                height: "15rem",
                backgroundColor: "#0C0A00",
                border:'1px solid #383838',
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                borderRadius: "10px",
                marginLeft:"10px",
                marginRight:"10px",
                padding:'1rem',
                flexDirection:'column',
                textAlign:'left'
              }}
              className='product-card'
            >
              <div style={{height:'70%',width:'100%', overflow:'hidden'}}>
                <img src={card.image} style={{objectFit:'contain',width:'100%', height:'100%'}}></img>
                

              </div>
              <h5 style={{width:'100%',marginTop:'1rem'}}>{card.name}</h5>
            <p style={{width:'100%', fontSize:'0.7rem', color:'white',paddingBottom:'0.9rem',marginBottom:'0.3rem'}}>{card.company}</p>
           
            </div>
            
          </div>
        ))}
      </Slider>
    </div>
            

            </div>
        
    

    </div>);

}

export default Products3;